import Modal from "../../../ui-kits/Modal";
import Slider from "../../../ui-kits/Slider";
import Close from "../../../assets/media/icons/close";
import styled from "styled-components";
import variables from "../../../assets/js/variables";
const { colors } = variables;

const FileModal = ({ isOpen, onClose, files, selectedIndex }) =>
  isOpen ? (
    <Modal>
      <StyledDialog>
        <div className="screen" onClick={onClose} />
        <div className="dialog_container border-blue rounded bg-background text-white p-2 p-md-3">
          <div className="p-1 p-md-2 mt-3">
            <div className="row mx-0">
              <div className="col-12 px-0">
                <Slider
                  settings={{
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    infinite: true,
                    initialSlide: selectedIndex,
                    autoplay: true,
                  }}
                >
                  {files.map((image) =>
                    image.includes("video") ? (
                      <div className="video_contain">
                        <iframe
                          src={image}
                          allowFullScreen="true"
                          title="fileModal"
                        />
                      </div>
                    ) : (
                      <div className="images_contain">
                        <img src={image} alt={image} />
                      </div>
                    )
                  )}
                </Slider>
              </div>
            </div>
          </div>
          <div className="text-left">
            <button onClick={onClose} className="close">
              <Close />
            </button>
          </div>
        </div>
      </StyledDialog>
    </Modal>
  ) : (
    <></>
  );

export default FileModal;

const StyledDialog = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  z-index: 1003;

  .screen {
    width: 100vw;
    height: 100vh;
    background: rebeccapurple;
    position: fixed;
    top: 0;
    background: rgba(0, 6, 50, 0.9);
  }
  .close {
    border: none;
    outline: none;
    background: ${colors.background};
    border: 2px solid white;
    border-radius: 50%;
    padding: 8px;
    background: none;
    @media (max-width: 600px) {
      padding: 6px;
    }
    svg {
      width: 26px;
      height: 26px;
      @media (max-width: 600px) {
        width: 20px;
        height: 20px;
      }
      path {
        stroke: ${colors.text};
        fill: ${colors.text};
      }
    }
  }
  .dialog_container {
    max-width: 80vw;
    width: fit-content;
    position: fixed;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    border: 1px solid;
    display: flex;
    flex-direction: column-reverse;
    .text-left {
      text-align: left;
    }

    .slick-slider {
      .slick-list {
        height: 100%;

        .slick-track {
          display: flex;
          align-items: center;

          .images_contain {
            overflow: hidden;
            padding: 0 10px;
            outline: unset !important;

            img {
              min-width: 100%;
              max-width: 100%;
              border-radius: 10px;
            }
          }

          .video_contain {
            overflow: hidden;
            padding: 0 10px;
            outline: unset !important;

            iframe {
              width: 100%;
              aspect-ratio: 16/9;
              border-radius: 10px;
            }
          }
        }
      }

      .slick-dots {
        top: -30px;
        bottom: unset;
        text-align: right;
      }
    }
  }

  @media (max-width: 768px) {
    .dialog_container {
      max-width: 95vw;

      .slick-slider .slick-list .slick-track .images_contain {
        padding: 0 5px;
      }
    }
  }
`;
